import { z } from 'zod';
import { postRequest } from './amplify/helpers';
import { SourceMediaAsset } from '@/types/media';

export type StockMediaAsset = SourceMediaAsset & { duration?: number };

export type StockMediaResponse = {
  page: number;
  total: number;
  hasNext: boolean;
  items: StockMediaAsset[];
};

export const GetStockMediaAssetsSchema = z.object({
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
  query: z.string().min(1),
});

export type GetStockMediaAssetsRequest = z.infer<typeof GetStockMediaAssetsSchema>;

export const getStockImages = async (request: GetStockMediaAssetsRequest): Promise<StockMediaResponse> => {
  return postRequest({
    apiName: 'studio',
    path: '/stock-media/images/list',
    options: {
      body: request,
    },
  });
};

export const getStockVideos = async (request: GetStockMediaAssetsRequest): Promise<StockMediaResponse> => {
  return postRequest({
    apiName: 'studio',
    path: '/stock-media/videos/list',
    options: {
      body: request,
    },
  });
};
